export default __webpack_public_path__ + "static/media/saved.0e7ad678.svg";